import { styled, Box } from '@mui/material'
import emotionStyled from '@emotion/styled/macro'
import { DateRangeCalendar } from '@mui/x-date-pickers-pro/DateRangeCalendar'
import theme from 'theme'

const INPUT_WIDTH = 240
const CALENDAR_WIDTH = 320
const CALENDAR_HEIGHT = 353

export const DateRangeWrapper = emotionStyled(Box)`
  .date-range-wrapper--label {
    color: ${theme.colors.menuItemText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 22px;
    margin-bottom: ${theme.spacing.xSmall}px;
  }

  .date-range-input-text {
    color: ${theme.colors.cta};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
  }
`

export const StyledDateRangeCalendar = styled(DateRangeCalendar)(() => ({
  backgroundColor: 'transparent',
  color: '#fff',

  '& .MuiDateRangeCalendar-monthContainer': {
    width: `${CALENDAR_WIDTH}px`,

    '& .MuiPickersCalendarHeader-root': {
      margin: '16px 28px 8px !important',
      padding: '0 !important',

      '& .MuiPickersCalendarHeader-label': {
        color: theme.colors.menuItemText,
        fontFamily: theme.typography.fontFamily.primary,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '20px'
      }
    },

    '& .MuiDayCalendar-header': {
      paddingLeft: '24px',
      paddingRight: '24px',

      '& .MuiDayCalendar-weekDayLabel': {
        color: theme.colors.cardDateText,
        fontSize: '12px',
        fontWeight: 400,
        width: '36px',
        height: '36px'
      }
    },

    '& .MuiPickersSlideTransition-root': {
      height: '200px !important',
      minHeight: '200px !important',

      '& .MuiDayCalendar-monthContainer': {
        paddingLeft: '16px',
        paddingRight: '16px'
      }
    }
  },

  '& .MuiPickersDay-root': {
    color: theme.colors.calendarDay,
    fontSize: theme.typography.fontSize.large,
    width: '36px',
    height: '36px',

    '&:hover': {
      backgroundColor: theme.colors.calendarActionHover
    },

    '&.Mui-selected': {
      backgroundColor: `${theme.colors.calendarRangeEndpoint} !important`,
      color: theme.colors.legacyWhite3,
      fontWeight: 500,

      '&:hover': {
        backgroundColor: `${theme.colors.calendarRangeEndpointHover} !important`
      }
    },

    '&.MuiDateRangePickerDay-dayInsideRangeInterval': {
      color: theme.colors.menuItemText
    },

    '&.MuiPickersDay-today': {
      border: '1px solid rgba(255, 255, 255, 0.3)',
      backgroundColor: 'transparent',

      '&.Mui-selected': {
        border: 'none'
      }
    }
  },

  '& .MuiDateRangePickerDay-root': {
    width: '38px !important',
    height: '36px !important',

    '&.MuiDateRangePickerDay-rangeIntervalDayHighlight': {
      background: theme.colors.devicesExclusionBtnBg,
      color: theme.colors.menuItemText,
      width: '38px !important',
      height: '36px !important',

      '&.MuiDateRangePickerDay-outsideCurrentMonth': {
        background: 'transparent'
      },

      '&:first-of-type': {
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px'
      },

      '&:last-of-type': {
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px'
      },

      '& .MuiDateRangePickerDay-rangeIntervalPreview': {
        width: '38px !important',
        height: '36px !important',

        button: {
          width: '34px !important',
          height: '32px !important'
        }
      }
    },

    '&.MuiDateRangePickerDay-rangeIntervalDayHighlightStart, &.MuiDateRangePickerDay-rangeIntervalDayHighlightEnd': {
      width: '38px !important',
      height: '36px !important',

      button: {
        width: '34px !important',
        height: '32px !important',
        color: theme.colors.surfaceContainerBackground,
        textAlign: 'center',
        fontFamily: theme.typography.fontFamily.primary,
        fontSize: theme.typography.fontSize.large,
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '20px'
      },

      '&:hover': {
        backgroundColor: '#6D28D9'
      }
    },

    '&.MuiDateRangePickerDay-rangeIntervalDayHighlightStart': {
      button: {
        borderRadius: '8px 0px 0px 8px !important',
        background: `${theme.colors.cta} !important`,

        '&.Mui-selected': {
          backgroundColor: `${theme.colors.cta} !important`,

          '&:hover': {
            backgroundColor: `${theme.colors.cta} !important`
          }
        }
      }
    },

    '&.MuiDateRangePickerDay-rangeIntervalDayHighlightEnd': {
      '.MuiDateRangePickerDay-rangeIntervalPreview': {
        width: '38px !important',
        height: '36px !important',

        button: {
          borderRadius: '0px 8px 8px 0px !important',
          background: `${theme.colors.cta} !important`
        }
      }
    },

    '& .MuiDateRangePickerDay-rangeIntervalPreview': {
      width: '38px !important',
      height: '36px !important',

      button: {
        width: '34px !important',
        height: '32px !important'
      },

      '& .Mui-disabled': {
        background: 'transparent !important',
        color: `${theme.colors.calendarDisabledDay} !important`
      }
    }
  },

  '& .MuiPickersArrowSwitcher-root': {
    '& .MuiIconButton-root': {
      color: theme.colors.calendarIcon,

      '&:hover': {
        backgroundColor: theme.colors.calendarActionHover
      },

      '&.Mui-disabled': {
        color: 'rgba(255, 255, 255, 0.3)'
      }
    }
  }
}))

export const ActionButtons = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: `${theme.spacing.md}px`,
  paddingTop: `${theme.spacing.xSmall}px`
})

export const StyledDatePickerWrapper = styled(Box)(() => ({
  backgroundColor: '#2D2D3B',
  borderRadius: theme.attributes.borderRadius.tertiary,
  padding: '16px',
  minWidth: `${INPUT_WIDTH}px`
}))

export const StyledInput = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: '14px 16px',
  backgroundColor: 'transparent',
  border: `1px solid ${theme.colors.dropdownBorder}`,
  borderRadius: theme.attributes.borderRadius.tertiary,
  cursor: 'pointer',
  minWidth: `${INPUT_WIDTH}px`,

  '&:hover': {
    border: `1px solid ${theme.colors.cta}`
  },

  '&:focus-within': {
    border: '1px solid rgba(255, 255, 255, 0.4)'
  },

  svg: {
    marginRight: '12px',
    fontSize: '20px',

    '& path': {
      stroke: theme.colors.cta
    }
  }
}))

export const popoverSx = {
  marginTop: `${theme.spacing.xSmall}px`,

  '.MuiPaper-root': {
    boxShadow: theme.colors.tooltipShadow,
    borderRadius: theme.attributes.borderRadius.tertiary,
    overflow: 'visible',

    '& > .MuiBox-root:first-child': {
      backgroundColor: `${theme.colors.calendarBg} !important`,
      width: `${CALENDAR_WIDTH}px !important`,
      height: `${CALENDAR_HEIGHT}px !important`,
      padding: 0
    }
  }
}
